import { ButtonHTMLAttributes, FC, MouseEventHandler } from 'react';
import './button.css';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}

export const Button: FC<Props> = ({
  text,
  disabled = false,
  ...props
}) => {

  return (
    <button
      className="button"
      disabled={disabled}
      {...props}
    >
      {text && (
        <span>
          {text}
        </span>
      )}
    </button>
  );
};